import castArray from "lodash/fp/castArray";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import map from "lodash/fp/map";

export const getFlatFieldsForCustomisation = flow(
  getOr([], ["fields"]),
  flatMap(castArray),
  flatMap(({ props = {}, fields = [], options = [], ...field }) => {
    return {
      ...field,
      options,

      // subFields can exist at:
      //  1. field.props.fields
      //  2. field.fields
      //  3. field.options[n].fields - each option could have fields
      fields: [
        ...(props.fields || []),
        ...fields,
        ...map(getOr([], "fields"))(options),
      ],
    };
  }),
  flatMap(({ fields, ...field }) => [
    field,
    ...getFlatFieldsForCustomisation({ fields }),
  ])
);

const getFlatFields = (productCustomisations) =>
  flatMap(getFlatFieldsForCustomisation)(productCustomisations);

export default getFlatFields;
